module.exports = __webpack_public_path__ + "static/foundation-intro-opt-dcc003b61e2b2fdac08c53f28e0c10f3.jpg";